export default __webpack_public_path__ + "static/media/analytics-marketing-team-5.47228654.svg";